/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { IbanVerification } from '../models/iban-verification';
import { JsonNode } from '../models/json-node';


/**
 * API to trigger iban verification
 */
@Injectable({
  providedIn: 'root',
})
export class IbanVerificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyIban
   */
  static readonly VerifyIbanPath = '/iban-verification';

  /**
   * Trigger IBAN verification for a country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyIban()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyIban$Response(params: {
    body: JsonNode
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IbanVerification>> {

    const rb = new RequestBuilder(this.rootUrl, IbanVerificationService.VerifyIbanPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IbanVerification>;
      })
    );
  }

  /**
   * Trigger IBAN verification for a country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyIban$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyIban(params: {
    body: JsonNode
  },
  context?: HttpContext

): Observable<IbanVerification> {

    return this.verifyIban$Response(params,context).pipe(
      map((r: StrictHttpResponse<IbanVerification>) => r.body as IbanVerification)
    );
  }

}
